<template>
  <div>
    <div class="d-flex">
      <h3 class="font-weight-regular page-title mt-0 mb-4">Projects</h3>
      <div class="search-container ml-16">
        <v-text-field
          v-model="searchText"
          solo
          flat
          hide-details
          dense
          background-color="rgba(0,0,0,0.1)"
          placeholder="Search projects"
          clearable
        />
      </div>
      <create-project />
    </div>
    <project-list-header />
    <div v-if="!loading">
      <project-list-item
        v-for="project in projects"
        :key="`project-${project.id}`"
        :project="project"
      />
      <v-container fluid>
        <v-row align="center" align-content="center" justify="center">
          <v-col class="d-flex" cols="1" sm="1">
            <small
              class="d-flex justify-right"
              style="width: 100%; white-space: nowrap"
            >
              Rows per page
            </small>
          </v-col>
          <v-col class="d-flex" cols="1 sm=1">
            <v-select
              v-model="rowsPerPageSelected"
              :items="rowsPerPageItems"
              :label="undefined"
              outlined
              dense
              hide-details
            >
              <template v-slot:selection="{ item }">
                <span class="d-flex justify-end" style="width: 100%">{{
                  item
                }}</span>
              </template>
            </v-select>
          </v-col>
          <v-col class="d-flex" cols="6" sm="3">
            <v-pagination
              v-if="pagination.total > 1"
              v-model="currentPage"
              :length="pagination.total"
              circle
              total-visible="6"
              color="secondary"
            />
          </v-col>
        </v-row>
      </v-container>
    </div>
    <v-progress-linear v-else indeterminate />
  </div>
</template>

<script>
import { debounce } from "lodash";
import ProjectListHeader from "@/components/pages/projects/ProjectListHeader";
import { mapActions, mapMutations, mapState } from "vuex";
import CreateProject from "./CreateProject";
import ProjectListItem from "./ProjectListItem.vue";

export default {
  name: "ProjectList",
  components: {
    CreateProject,
    ProjectListHeader,
    ProjectListItem,
  },
  data() {
    return {
      loading: true,
      inProgress: false,
      rowsPerPageItems: [10, 25, 50],
    };
  },
  computed: {
    ...mapState("projects", ["projects", "pagination"]),
    searchText: {
      get() {
        return this.pagination.searchText;
      },
      set: debounce(function (value) {
        this.setSearchText(value);
        this.setCurrentPage(1);
        this.loadProjects(true);
      }, 400),
    },
    rowsPerPageSelected: {
      get() {
        return this.pagination.pageSize;
      },
      set(value) {
        this.setCurrentPage(1);
        this.setPageSize(value);
        this.loadProjects(true);
      },
    },
    currentPage: {
      get() {
        return this.pagination.current;
      },
      set(value) {
        this.setCurrentPage(value);
        this.loadProjects(true);
      },
    },
  },
  methods: {
    ...mapActions("projects", ["getProjects"]),
    ...mapMutations("projects", [
      "setCurrentPage",
      "setPageSize",
      "setSearchText",
    ]),
    async loadProjects(reload) {
      this.loading = reload;
      await this.getProjects();
      this.loading = false;
    },
  },
  mounted() {
    this.setCurrentPage(1);
    this.loadProjects(true);
  },
};
</script>

<style scoped>
.page-title {
  color: #3e3e3e;
}
</style>
